import { Box, Flex } from 'reflexbox';
import { useTranslation } from 'react-i18next';

import * as graphql from 'generated/graphql';
import PlainButton from 'packages/kakapo-ui-kit/components/buttons/PlainButton';
import Paragraph from 'packages/kakapo-ui-kit/components/common/Paragraph';
import Modal, {
	ModalBackground,
	ModalContent,
} from 'packages/kakapo-ui-kit/components/modals/Modal';
import ModalFooter from 'packages/kakapo-ui-kit/components/modals/ModalFooter';
import ModalHeader from 'packages/kakapo-ui-kit/components/modals/ModalHeader';
import PrimaryButton from 'packages/kakapo-ui-kit/components/buttons/PrimaryButton';
import Spinner from 'packages/kakapo-ui-kit/components/common/Spinner';

export default function EvaluationSubmissionShareModal(props: {
	submission: graphql.EvaluationSubmission;
	attempt: <F extends Function>(fn: F) => F;
	onDismiss: () => void;
}) {
	const { t } = useTranslation();

	const [mark, { loading }] = graphql.useMarkEvaluationSubmissionSharedMutation({
		variables: { input: { id: props.submission.id } },
	});

	return (
		<ModalBackground>
			<Modal>
				<ModalHeader>{t('evaluation.submission.share.modal.title')}</ModalHeader>
				<ModalContent>
					<Paragraph>{t('evaluation.submission.share.modal.description')}</Paragraph>
				</ModalContent>
				<ModalFooter>
					{loading ? (
						<Spinner isLoading size="18px" />
					) : (
						<Flex px={3} alignItems="center" justifyContent="flex-end">
							<Box mr={3}>
								<PlainButton onClick={() => props.onDismiss()}>
									{t('evaluation.submission.share.modal.cancel')}
								</PlainButton>
							</Box>
							<PrimaryButton
								onClick={props.attempt(async () => {
									try {
										await mark();
										window.scrollTo(0, 0);
									} catch (error) {
										throw error;
									} finally {
										props.onDismiss();
									}
								})}
							>
								{t('evaluation.submission.share.modal.confirm')}
							</PrimaryButton>
						</Flex>
					)}
				</ModalFooter>
			</Modal>
		</ModalBackground>
	);
}
